<template>
  <div class="specific-fields">
    <div class="specific-fields-title" v-if="isSomeFieldVisible">Item {{ this.$vnode.key }}</div>
    <div class="inputs">
      <div v-if="getSerieNumberStatus">
        <label :for="getDynamicNameItem('item-serie-number')"
          >Número de Série</label
        >
        <input
          :id="getDynamicNameItem('item-serie-number')"
          placeholder="Número de série"
          type="text"
          v-model="serieNumber"
        />
        <span
          class="error-text"
          v-if="getSerieNumberStatus && !serieNumber && showErrors"
          >*Numero de série inválido</span
        >
      </div>
      <div v-if="getExchnageCertificateStatus">
        <label :for="getDynamicNameItem('item-exchange-certificate')"
          >Comprovante de Troca</label
        >
        <input
          :id="getDynamicNameItem('item-exchange-certificate')"
          placeholder="Comprovante de troca"
          type="text"
          v-model="exchangeCertificate"
        />
        <span
          class="error-text"
          v-if="
            getExchnageCertificateStatus && !exchangeCertificate && showErrors
          "
          >*Comprovante de troca inválido</span
        >
      </div>
      <div v-if="getPAcodeStatus">
        <label :for="getDynamicNameItem('item-pacode')">Código PA</label>
        <input
          :id="getDynamicNameItem('item-pacode')"
          placeholder="Código PA"
          type="text"
          v-model="PAcode"
        />
        <span class="error-text" v-if="getPAcodeStatus && !PAcode && showErrors"
          >*Código PA inválido</span
        >
      </div>
      <div v-if="getPAengineeringVersionStatus">
        <label :for="getDynamicNameItem('item-paengineering-version')"
          >Versão engenharia PA</label
        >
        <input
          :id="getDynamicNameItem('item-paengineering-version')"
          placeholder="Versão engenharia PA"
          type="text"
          v-model="PAengineeringVersion"
        />
        <span
          class="error-text"
          v-if="
            getPAengineeringVersionStatus && !PAengineeringVersion && showErrors
          "
          >*Versão engenharia PA inválida</span
        >
      </div>
      <div v-if="getPAserieNumberStatus">
        <label :for="getDynamicNameItem('item-paserie-number')"
          >Número de série PA</label
        >
        <input
          :id="getDynamicNameItem('item-paserie-number')"
          placeholder="Número de série PA"
          type="text"
          v-model="PAserieNumber"
        />
        <span
          class="error-text"
          v-if="getPAserieNumberStatus && !PAserieNumber && showErrors"
          >*Numero de série PA inválido</span
        >
      </div>
    </div>
    <div class="photos">
      <div class="photo-input" v-if="getWarrantyCertificatePhotoStatus">
        <label class="text"
          >Certificado de Garantia (*Tamanho máximo permitido 1,5M):</label
        >
        <div class="upload-content">
          <label
            class="upload-file-mask"
            :for="getDynamicNameItem('item-warranty-upload')"
            >Selecionar Arquivo</label
          >
          <input
            type="text"
            :id="getDynamicNameItem('item-warranty-upload-name')"
            v-model="warrantyUploadName"
            class="upload-file-name"
            disabled
          />
          <input
            :id="getDynamicNameItem('item-warranty-upload')"
            class="upload-file"
            type="file"
            @change="setNameOfFile($event, 'warranty-photo')"
          />
          <input name="warranty" id="warranty" type="file" v-show="false" />
        </div>
      </div>
      <div class="photo-input" v-if="getInvoicePhotoStatus">
        <label class="text"
          >Foto da Nota Fiscal (*Tamanho máximo permitido 1,5M):</label
        >
        <div class="upload-content">
          <label
            class="upload-file-mask"
            :for="getDynamicNameItem('item-invoice-upload')"
            >Selecionar Arquivo</label
          >
          <input
            :id="getDynamicNameItem('item-invoice-upload-name')"
            v-model="invoiceUploadName"
            type="text"
            class="upload-file-name"
            disabled
          />
          <input
            :id="getDynamicNameItem('item-invoice-upload')"
            class="upload-file"
            type="file"
            @change="setNameOfFile($event, 'invoice-photo')"
          />
          <input name="invoice" id="invoice" type="file" v-show="false" />
        </div>
      </div>
      <div class="photo-input" v-if="getBoxTicketPhotoStatus">
        <label class="text"
          >Foto da etiqueta da caixa (*Tamanho máximo permitido 1,5M):</label
        >
        <div class="upload-content">
          <label
            class="upload-file-mask"
            :for="getDynamicNameItem('item-box-ticket-upload')"
            >Selecionar Arquivo</label
          >
          <input
            type="text"
            :id="getDynamicNameItem('item-box-ticket-upload-name')"
            v-model="boxTicketUploadName"
            class="upload-file-name"
            disabled
          />
          <input
            :id="getDynamicNameItem('item-box-ticket-upload')"
            class="upload-file"
            type="file"
            @change="setNameOfFile($event, 'box-ticket-photo')"
          />
          <input name="boxTicket" id="boxTicket" type="file" v-show="false" />
        </div>
      </div>
      <div class="photo-input" v-if="getPartPhotoStatus">
        <label class="text"
          >Foto da peça (*Tamanho máximo permitido 1,5M):</label
        >
        <div class="upload-content">
          <label
            :for="getDynamicNameItem('item-part-photo-upload')"
            class="upload-file-mask"
            >Selecionar Arquivo</label
          >
          <input
            type="text"
            :id="getDynamicNameItem('item-part-photo-upload-name')"
            v-model="partPhotoUploadName"
            class="upload-file-name"
            disabled
          />
          <input
            :id="getDynamicNameItem('item-part-photo-upload')"
            class="upload-file"
            type="file"
            @change="setNameOfFile($event, 'part-photo')"
          />
          <input name="partPhoto" id="partPhoto" type="file" v-show="false" />
        </div>
      </div>
      <div class="errors-list">
        <span
          class="error-text"
          v-if="
            getWarrantyCertificatePhotoStatus &&
              !isWarrantyUpdated &&
              showErrors
          "
          >*Certificado de garantia inválido</span
        >
        <span
          class="error-text"
          v-if="getInvoicePhotoStatus && !isInvoiceUpdated && showErrors"
          >*Foto da nota fiscal inválida</span
        >
        <span
          class="error-text"
          v-if="getBoxTicketPhotoStatus && !isBoxTicketUpdated && showErrors"
          >*Foto da etiqueta da caixa inválida</span
        >
        <span
          class="error-text"
          v-if="getPartPhotoStatus && !isPartPhotoUpdated && showErrors"
          >*Foto da peça inválida</span
        >
        <span class="error-text" v-if="fileSizeError"
          >*Tamanho maior que o permitido.</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/eventHub";
import SpecificFieldsService from "@/services/return-solicitation/specific-fields-service.js";

export default {
  name: "SpecificFields",
  props: {
    id: Number,
    invoiceIndex: Number,
    cause: String,
    subFamily: String,
    isGettingSpecificFieldsData: Boolean
  },
  data() {
    return {
      compressor: "Compressores Herméticos Embraco",

      warrantyUploadName: null,
      invoiceUploadName: null,
      boxTicketUploadName: null,
      partPhotoUploadName: null,
      serieNumber: null,
      isSerieNumberVisible: false,

      warrantyCertifcatePhoto: Blob,
      isWarrantyUpdated: false,
      isWarrantyCertificateVisible: false,

      invoicePhoto: Blob,
      isInvoiceUpdated: false,
      isInvoiceVisible: false,

      boxTicketPhoto: Blob,
      isBoxTicketUpdated: false,
      isBoxTicketVisible: false,

      partPhoto: Blob,
      isPartPhotoUpdated: false,
      isPartPhotoVisible: false,

      exchangeCertificate: null,
      isExchangeCertificateVisible: false,

      PAcode: null,
      isPAcodeVisible: false,

      PAengineeringVersion: null,
      isPAengineeringVersionVisible: false,

      PAserieNumber: null,
      isPAserieNumberVisible: false,

      showErrors: false,
      areFieldsLoaded: false,

      fileSizeError: false
    };
  },
  watch: {
    cause: function() {
      this.setVisibleFields();
    },
    subFamily: function() {
      this.setVisibleFields();
    },
    isGettingSpecificFieldsData: function() {
      if (this.isGettingSpecificFieldsData) {
        this.$emit("sendSpecificFieldsData", {
          field_serie_number: this.serieNumber,
          field_warranty_photo: this.warrantyCertifcatePhoto,
          field_invoice_photo: this.invoicePhoto,
          field_cashier_tag: this.boxTicketPhoto,
          field_material_photo: this.partPhoto,
          field_exchange_voucher: this.exchangeCertificate,
          field_pa_code: this.PAcode,
          field_pa_engineering_version: this.PAengineeringVersion,
          field_pa_serie_number: this.PAserieNumber
        });
      }
    }
  },
  methods: {
    setVisibleFields() {
      SpecificFieldsService.getSpecificFields(this.subFamily, this.getCode())
        .then(response => {
          let fields = SpecificFieldsService.parseSpecificFields(
            response.data[0]
          );
          this.setFieldsValues(fields);
          this.areFieldsLoaded = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDynamicNameItem(name) {
      return `${this.invoiceIndex + 1}-invoice-${name}-input-${this.id + 1}-${this.$vnode.key}`;
    },
    isEmbracoCompressor() {
      return this.subFamily.toLowerCase() == this.compressor.toLowerCase();
    },
    getCode() {
      // TODO: build a parser to get the code correctly from back-end.
      return parseInt(this.cause.split(" - ")[0]);
    },
    setNameOfFile(event, value) {
      this.fileSizeError = false;
      const fileData = event.target.files[0];
      const size = fileData.size;
      if (size > 1500000) {
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        const imgSrc = null;
        const reader = new FileReader();
        let self = this;
        reader.onload = event => {
          self.imgSrc = event.target.result;
          this.setFileNames(value, self.imgSrc, fileData);
        };
        reader.onerror = error => {
          console.log(error);
        };
        reader.readAsDataURL(fileData);
      }
    },
    setFileNames(value, imgSrc, fileData) {
      switch (value) {
        case "warranty-photo":
          this.warrantyUploadName = fileData.name;
          this.warrantyCertifcatePhoto = imgSrc;
          this.isWarrantyUpdated = true;
          break;
        case "invoice-photo":
          this.invoiceUploadName = fileData.name;
          this.invoicePhoto = imgSrc;
          this.isInvoiceUpdated = true;
          break;
        case "box-ticket-photo":
          this.boxTicketUploadName = fileData.name;
          this.boxTicketPhoto = imgSrc;
          this.isBoxTicketUpdated = true;
          break;
        case "part-photo":
          this.partPhotoUploadName = fileData.name;
          this.partPhoto = imgSrc;
          this.isPartPhotoUpdated = true;
          break;
      }
    },
    setFieldsValues(fieldsToShow) {
      this.isSerieNumberVisible = fieldsToShow.fieldSerieNumber;
      this.isWarrantyCertificateVisible = fieldsToShow.fieldWarrantyPhoto;
      this.isInvoiceVisible = fieldsToShow.fieldInvoicePhoto;
      this.isBoxTicketVisible = fieldsToShow.fieldCashierTag;
      this.isPartPhotoVisible = fieldsToShow.fieldMaterialPhoto;
      this.isExchangeCertificateVisible = fieldsToShow.fieldExchangeVoucher;
      this.isPAcodeVisible = fieldsToShow.fieldPaCode;
      this.isPAengineeringVersionVisible =
        fieldsToShow.fieldPaEngineeringVersion;
      this.isPAserieNumberVisible = fieldsToShow.fieldPaSerieNumber;
    },
    haveNotChangedField() {
      return (
        (this.getWarrantyCertificatePhotoStatus && !this.isWarrantyUpdated) ||
        (this.getInvoicePhotoStatus && !this.isInvoiceUpdated) ||
        (this.getBoxTicketPhotoStatus && !this.isBoxTicketUpdated) ||
        (this.getPartPhotoStatus && !this.isPartPhotoUpdated) ||
        (this.getSerieNumberStatus && !this.serieNumber) ||
        (this.getExchnageCertificateStatus && !this.exchangeCertificate) ||
        (this.getPAcodeStatus && !this.PAcode) ||
        (this.getPAengineeringVersionStatus && !this.PAengineeringVersion) ||
        (this.getPAserieNumberStatus && !this.PAserieNumber)
      );
    },
    emitFields() {
      this.$emit(
        "updateFields",
              {id: this.$vnode.key, status: !this.haveNotChangedField() && this.areFieldsLoaded }
      );
    },
    clearFields() {
      (this.compressor = "Compressores Herméticos Embraco"),
        (this.warrantyUploadName = null),
        (this.invoiceUploadName = null),
        (this.boxTicketUploadName = null),
        (this.partPhotoUploadName = null),
        (this.serieNumber = null),
        (this.isSerieNumberVisible = false),
        (this.warrantyCertifcatePhoto = Blob),
        (this.isWarrantyUpdated = false),
        (this.isWarrantyCertificateVisible = false),
        (this.invoicePhoto = Blob),
        (this.isInvoiceUpdated = false),
        (this.isInvoiceVisible = false),
        (this.boxTicketPhoto = Blob),
        (this.isBoxTicketUpdated = false),
        (this.isBoxTicketVisible = false),
        (this.partPhoto = Blob),
        (this.isPartPhotoUpdated = false),
        (this.isPartPhotoVisible = false),
        (this.exchangeCertificate = null),
        (this.isExchangeCertificateVisible = false),
        (this.PAcode = null),
        (this.isPAcodeVisible = false),
        (this.PAengineeringVersion = null),
        (this.isPAengineeringVersionVisible = false),
        (this.PAserieNumber = null),
        (this.isPAserieNumberVisible = false),
        (this.showErrors = false);
    }
  },
  computed: {
    isSomeFieldVisible() {
      if(this.isSerieNumberVisible || this.isWarrantyCertificateVisible
              || this.isInvoiceVisible || this.isBoxTicketVisible || this.isPartPhotoVisible
              || this.isExchangeCertificateVisible || this.isPAcodeVisible || this.isPAengineeringVersionVisible
              || this.isPAserieNumberVisible
      ){
        return true
      }else{
        return false
      }
    },
    getSerieNumberStatus() {
      return this.isSerieNumberVisible;
    },
    getWarrantyCertificatePhotoStatus() {
      return this.isWarrantyCertificateVisible;
    },
    getInvoicePhotoStatus() {
      return this.isInvoiceVisible;
    },
    getBoxTicketPhotoStatus() {
      return this.isBoxTicketVisible;
    },
    getPartPhotoStatus() {
      return this.isPartPhotoVisible;
    },
    getExchnageCertificateStatus() {
      return this.isExchangeCertificateVisible;
    },
    getPAcodeStatus() {
      return this.isPAcodeVisible;
    },
    getPAengineeringVersionStatus() {
      return this.isPAengineeringVersionVisible;
    },
    getPAserieNumberStatus() {
      return this.isPAserieNumberVisible;
    }
  },
  created() {
    EventBus.$on("sendClicked", () => {
      this.showErrors = true;
      this.emitFields();
    });
    EventBus.$on("clearField", () => {
      this.clearFields();
    });
    this.setVisibleFields();
  },
  updated() {
    this.emitFields();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.specific-fields {
  box-sizing: border-box;
  width: 100%;

  .inputs {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-left: 13px;
    box-sizing: border-box;

    & > div {
      display: flex;
      width: 45%;
      margin-right: 20px;
      margin-bottom: 20px;
      flex-direction: column;

      & > input {
        width: 90%;
      }
    }
  }
  .specific-fields-title{
    padding-left: 13px;
    margin-bottom: 20px;
  }

  .photos {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 13px;
    padding-right: 13px;
    padding-bottom: 13px;
    box-sizing: border-box;

    .photo-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      border-left: 1px solid $grey6;
      border-bottom: 1px solid $grey6;
      box-sizing: border-box;
      padding-bottom: 10px;
      padding-left: 10px;
      margin-top: 10px;

      .text {
        margin-right: 20px;
      }

      .upload-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 51%;
        height: 39px;

        input[type="file"] {
          display: none;
        }

        .upload-file-name {
          width: 64%;
          height: 29px;
          border: none;
          background-color: $white;
        }

        .upload-file-mask {
          background-color: $orange1;
          color: $white;
          text-align: center;
          height: 20px;
          line-height: 20px;
          text-transform: uppercase;
          font-size: 12px;
          font-weight: bold;
          margin: 0;
          width: 140px;
          padding: 10px;
          cursor: pointer;

          &:hover {
            transition: 0.7s;
            background-color: $orange2;
          }
        }

        .upload-file {
          display: flex;
          align-items: center;
          padding: 0;
          height: auto;
          width: auto;
          border: none;
          margin-bottom: 3px;
        }
      }
    }
  }
}

.errors-list {
  display: flex;
  flex-direction: column;
}

// @media (min-width: 1272px) and (max-width: 1584px) {
//   .specific-fields {
//     .photos {
//       .photo-input {
//         .upload-content {
//           .upload-file-mask {
//             padding: 2.5%;
//             cursor: pointer;
//           }
//         }
//       }
//     }
//   }
// }

// @media (min-width: 1585px) and (max-width: 1669px) {
//   .specific-fields {
//     .photos {
//       .photo-input {
//         .upload-content {
//           .upload-file-mask {
//             padding: 2.1%;
//           }
//         }
//       }
//     }
//   }
// }
</style>
